import FieldController from "../field.controller";

class MultiSelectCheckboxFieldController extends FieldController {
  constructor($scope, $q, $translate, $log, $timeout, $document) {
    "ngInject";
    super($scope, $q, $translate, $log, $timeout);

    // Function to handle document click
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    // Attach the click event listener to the document
    $document.on("click", this.handleDocumentClick);

    // Cleanup: Remove the click event listener when the component is destroyed
    $scope.$on("$destroy", () => {
      $document.off("click", this.handleDocumentClick);
    });
  }

  handleDocumentClick(event) {
    if (!this.dropdown) {
      return;
    }
    // Check if the click target is outside the component
    const el = document.getElementById(
      `field_${this.fieldInstance.id}_response_${this.fieldResponse.id}_list`
    );
    if (el && !el.contains(event.target)) {
      this.$scope.$evalAsync(() => {
        this.dropdown = false;
      });
    }
  }

  get selectedCount() {
    return this.optionsWithSelected.filter((o) => o.selected).length;
  }

  get optionsWithSelected() {
    if (
      this._optionsWithSelected === undefined ||
      this.$scope.shouldUpdateOptions
    ) {
      const selectedOptionIds =
        (this.value &&
          this.value
            .toString()
            .split(/[|,]/)
            .map((id) => parseInt(id))) ||
        [];
      this._optionsWithSelected = (this.$scope.filteredOptions || []).map(
        (option) => {
          const selected =
            selectedOptionIds.indexOf(parseInt(option.id)) !== -1;
          return { option, selected };
        }
      );
      this.$scope.shouldUpdateOptions = false;
    }
    return this._optionsWithSelected;
  }

  set optionsWithSelected(optionsWithSelected) {
    this._optionsWithSelected = optionsWithSelected;
  }

  checkAllSelected() {
    this.allSelected = this.selectedCount == this.optionsWithSelected.length;
  }

  selectAll() {
    if (this.selectedCount == this.optionsWithSelected.length) {
      this.optionsWithSelected.forEach((o) => {
        o.selected = false;
      });
    } else {
      this.optionsWithSelected.forEach((o) => {
        o.selected = true;
      });
    }
    this.updateResponseValue();
  }

  updateResponseValue() {
    const selectedOptionIds = this.optionsWithSelected
      .filter((o) => o.selected)
      .map((o) => o.option.id);
    this.value = selectedOptionIds.join("|");
  }
}

export default MultiSelectCheckboxFieldController;
